import { Carousel, Typography } from 'antd';
import { ArrowLeftOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useRef, useState } from 'react';
import Nudge from '../../../../Models/Nudge';
import NudgeDetails from '../NudgeDetails';
import styles from './index.module.css';

const NudgesPage: React.FC<{
  nudgeList: Nudge[];
  onBack: () => void;
}> = ({ nudgeList, onBack }) => {
  const carouselRef = useRef<any>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    carouselRef.current?.prev();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  const handleBeforeChange = (_: number, next: number) => {
    setCurrentIndex(next);
  };

  return (
    <div className={styles.nudgesPage}>
      <div className={styles.header}>
        <button className={styles.backBtn} onClick={onBack}>
          <ArrowLeftOutlined />
        </button>
        <Typography.Text className={styles.title}>
          Tips & Recommendations
        </Typography.Text>
        <div className={styles.counter}>
          {currentIndex + 1} / {nudgeList.length}
        </div>
      </div>

      <div className={styles.carouselContainer}>
        <Carousel
          ref={carouselRef}
          autoplay
          autoplaySpeed={5000}
          speed={500}
          dots={false}
          infinite
          draggable
          beforeChange={handleBeforeChange}
        >
          {nudgeList.map((nudge) => (
            <div key={nudge.id} className={styles.slideWrapper}>
              <div className={styles.cardContainer}>
                <NudgeDetails nudge={nudge} />
              </div>
            </div>
          ))}
        </Carousel>

        <div className={styles.navigationControls}>
          <button className={styles.navBtn} onClick={handlePrev}>
            <LeftOutlined />
          </button>
          <div className={styles.dotsContainer}>
            {nudgeList.map((_, index) => (
              <div
                key={index}
                className={`${styles.dot} ${index === currentIndex ? styles.activeDot : ''}`}
                onClick={() => carouselRef.current?.goTo(index)}
              />
            ))}
          </div>
          <button className={styles.navBtn} onClick={handleNext}>
            <RightOutlined />
          </button>
        </div>
      </div>

      <div className={styles.swipeHint}>
        <Typography.Text className={styles.hintText}>
          Swipe or use arrows to browse tips
        </Typography.Text>
      </div>
    </div>
  );
};

export default NudgesPage;
